import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { COMPANY } from "../data/site";

export default function Footer() {
  return (
    <footer style={{ background: "var(--ink-3)", color: "#fff" }} data-testid="site-footer">
      <div className="container-x py-16">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <Logo light size={56} />
            <p
              className="mt-5 text-sm leading-relaxed"
              style={{ color: "rgba(255,255,255,0.55)" }}
            >
              Ménage professionnel et conciergerie haut de gamme pour vos
              locations saisonnières à Béziers et sur le littoral héraultais.
            </p>
          </div>

          <div>
            <h4 className="eyebrow mb-5">Services</h4>
            <ul className="space-y-3 text-sm" style={{ color: "rgba(255,255,255,0.7)" }}>
              <FootLink to="/menage" label="Ménage professionnel" />
              <FootLink to="/conciergerie" label="Conciergerie" />
              <FootLink to="/nos-services/applications" label="Applications" />
            </ul>
          </div>

          <div>
            <h4 className="eyebrow mb-5">Entreprise</h4>
            <ul className="space-y-3 text-sm" style={{ color: "rgba(255,255,255,0.7)" }}>
              <FootLink to="/a-propos" label="Notre histoire" />
              <FootLink to="/a-propos/faq-generale" label="FAQ" />
              <FootLink to="/contact" label="Contact" />
              <FootLink to="/contact/mentions-legales" label="Mentions légales" />
              <FootLink to="/contact/cgv" label="CGV" />
              <FootLink to="/contact/politique-de-confidentialite" label="Confidentialité" />
            </ul>
          </div>

          <div>
            <h4 className="eyebrow mb-5">Contact</h4>
            <ul className="space-y-4 text-sm" style={{ color: "rgba(255,255,255,0.7)" }}>
              <li className="flex items-start gap-3">
                <Phone size={16} style={{ color: "var(--gold)", marginTop: 2 }} />
                <a href={`tel:${COMPANY.phoneIntl}`}>{COMPANY.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} style={{ color: "var(--gold)", marginTop: 2 }} />
                Béziers & littoral héraultais
              </li>
              <li className="flex items-start gap-3">
                <Clock size={16} style={{ color: "var(--gold)", marginTop: 2 }} />
                Disponible 7j/7
              </li>
            </ul>
            <a
              href={COMPANY.whatsapp}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-sm"
              style={{ color: "var(--gold-2)" }}
            >
              Contacter via WhatsApp <ArrowUpRight size={15} />
            </a>
          </div>
        </div>

        <div
          className="mt-14 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs"
          style={{ borderTop: "1px solid rgba(255,255,255,0.12)", color: "rgba(255,255,255,0.45)" }}
        >
          <p>© {new Date().getFullYear()} {COMPANY.name}. Tous droits réservés.</p>
          <p>Conciergerie & ménage Airbnb · Béziers · Cap d'Agde · Valras · Sérignan</p>
        </div>
      </div>
    </footer>
  );
}

function FootLink({ to, label }) {
  return (
    <li>
      <Link
        to={to}
        className="transition-colors"
        onMouseEnter={(e) => (e.currentTarget.style.color = "var(--gold-2)")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "inherit")}
      >
        {label}
      </Link>
    </li>
  );
}
